interface AppConfig {
  BASE_URL: string;
  BASE_URL2: string;
  GOOGLE_CLIENT_ID: string;
}

declare global {
  interface Window {
    APP_CONFIG?: AppConfig;
  }
}

// Fallback keeps `npm run serve` working for local dev. When the
// webpack dev server runs, window.APP_CONFIG is undefined, so we
// read Vue CLI's .env.development at build time via process.env.
const fallback: AppConfig = {
  BASE_URL: process.env.VUE_APP_BASE_URL || '',
  BASE_URL2: process.env.VUE_APP_BASE_URL2 || '',
  GOOGLE_CLIENT_ID: process.env.VUE_APP_GOOGLE_CLIENT_ID || '',
};

export const config: AppConfig = window.APP_CONFIG ?? fallback;
